/******************
* Javascript for 'contentalternative:' Kirby tag
*******************/

if(typeof FN == 'undefined') FN = {};


FN.contentalternative = {
  init: function(){
    if(!$('.contentalternative__selector')) return;
    
    // show each block's active container
    var blocks = $('.contentalternative__selector').each(function(){
      FN.contentalternative.showActive($(this));
    });
    
    // event handler for option links
    $('.contentalternative__option').on('click', function(){
      FN.contentalternative.changeActiveOption($(this));
    });
  },
  currentOption: function(optionSelector){
    // returns the index of the selected option
    var active = 0;
    var options = $(optionSelector).find('.contentalternative__option');
    for(var i=0; i<options.length; i++){
      if($(options[i]).hasClass('contentalternative__option--active')){
        active = i;
        break;
      }
    }
    return active;
  },
  changeActiveOption: function(option){
    var optionSelector = $(option).closest('.contentalternative__selector');
    $(optionSelector).find('.contentalternative__option').each(function(){
      if($(this).is(option)){
        $(this).addClass('contentalternative__option--active');
      }else{
        $(this).removeClass('contentalternative__option--active');
      }
    });
    
    FN.contentalternative.showActive(optionSelector);
  },
  showActive: function(optionSelector){
    var active = FN.contentalternative.currentOption(optionSelector);
    var options = $(optionSelector).find('.contentalternative__option');

    var parsePosition = optionSelector;
    for(var i=0; i<options.length; i++){
      var content = $(parsePosition).nextUntil('hr.contentalternative__separator');
      if(i === active){
        content.show();
      }else{
        content.hide();
      }
      parsePosition = content.nextAll('hr.contentalternative__separator').first();
    }
  }
};




$(document).ready(function(){
  FN.contentalternative.init();
});
